"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizeBy = void 0;
const memoize_state_1 = __importDefault(require("memoize-state"));
/**
 * Memoize a function, using the `getKey` function to create separately-memoized
 * copies.
 */
const memoizeBy = (getKey, fn) => {
    const memoizedFns = {};
    function clear(...args) {
        delete memoizedFns[getKey(...args)];
    }
    return Object.assign(((...args) => {
        const key = getKey(...args);
        if (!memoizedFns[key]) {
            memoizedFns[key] = memoize_state_1.default(fn);
        }
        return memoizedFns[key](...args);
    }), { clear });
};
exports.memoizeBy = memoizeBy;
